"use client";

import { useState } from "react";
import { CloseButton } from "../../icons";

import styles from "./HeaderPromoBanner.module.scss";

interface HeaderPromoBannerProps {
  textColor?: string;
  backgroundColor?: string;
  format?: "US" | "UK";
}

const contentUS =
  "<strong>Level up for less.</strong> Take a strategic step toward your goals. Get <strong>15% off course fees</strong> until July 30, 2025 with code <strong>LEVELUP25.</strong>";

const contentUK =
  "<strong>Level up for less.</strong> Take a strategic step toward your goals. Get <strong>15% off course fees</strong> until 30 July 2025 with code <strong>LEVELUP25.</strong>";
export const ExecEdHeaderPromoBanner = function ({
  textColor,
  backgroundColor,
  format = "US",
}: HeaderPromoBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div
      id="headerPromoBanner"
      className={`${styles.wrapper} ${isVisible ? styles.visible : styles.hidden}`}
      style={{ backgroundColor }}
    >
      <div className={styles.container}>
        <p dangerouslySetInnerHTML={{ __html: format == "UK" ? contentUK : contentUS }} style={{ color: textColor }} />
        <button className={styles.closeButton} onClick={handleClose}>
          <CloseButton fill={textColor} />
        </button>
      </div>
    </div>
  );
};
